import { useCopilotWidget } from '@modules/copilot/hooks/useCopilotWidget';
import { useUser } from 'app/_providers/User';
import { useWorkspace } from 'app/_providers/WorkspaceProvider';

import Script from 'next/script';
import React, { useEffect, useState } from 'react';

const COPILOT_API_URL = process.env.CRIBL_AI_API_URL;
const COPILOT_SCRIPT_URL = process.env.CRIBL_AI_SCRIPT_URL;

export const CopilotScript: React.FC = () => {
  const user = useUser();
  const { leaderFQDN } = useWorkspace();
  const { data: isCopilotWidgetEnabled, isLoading: loadingCopilotWidget } = useCopilotWidget(leaderFQDN);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const handleScriptLoad = () => {
    setScriptLoaded(true);
  };

  useEffect(() => {
    if (scriptLoaded && user && user.email && !loadingCopilotWidget && isCopilotWidgetEnabled) {
      window.CriblCopilot?.init({
        product: 'saas-cribl',
        isDev: process.env.NODE_ENV === 'development',
        auth: {},
        userInfo: {
          email: user.email,
          name: user.givenName,
          lastName: user.familyName,
          initials: `${user.givenName?.charAt(0) ?? ''}${user.familyName?.charAt(0) ?? ''}`,
        },
        baseUrl: COPILOT_API_URL,
        styles: { position: { bottom: '20px', right: '20px' } },
      });
    } else if (!loadingCopilotWidget && !isCopilotWidgetEnabled) {
      const copilotContainer = document.getElementById('cribl-copilot-container');

      if (copilotContainer) {
        copilotContainer.remove();
      }
    }
  }, [scriptLoaded, user, isCopilotWidgetEnabled, loadingCopilotWidget]);

  const shouldRenderScript = !!COPILOT_SCRIPT_URL && !loadingCopilotWidget && isCopilotWidgetEnabled;

  if (!shouldRenderScript) {
    return null;
  }

  return <Script src={COPILOT_SCRIPT_URL} strategy='lazyOnload' onLoad={handleScriptLoad} />;
};
